import { render, staticRenderFns } from "./od_tag_input.vue?vue&type=template&id=749cf285&scoped=true&"
import script from "./od_tag_input.vue?vue&type=script&lang=js&"
export * from "./od_tag_input.vue?vue&type=script&lang=js&"
import style0 from "./od_tag_input.vue?vue&type=style&index=0&id=749cf285&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749cf285",
  null
  
)

export default component.exports